import { PagedResult } from "./IPagingResponseModel.interface";

export interface ILinkedCampaign {
  id: number;
  campaignId: string;
  campaignDisplayName: string;
  startDate?: string | null;
  endDate?: string | null;
  stringStartDate: string;
  stringEndDate: string;
  campaignStatus: number;
  campaignType: number;
  registrationSubType?: number | null; // RegistrationCampaignSubTypeEnum value, only set for Registration campaigns
  accessType: number;
  aboutTheCampaign: string;
  campaignDetail: string;
  blobUrls: string;
  eventAddress?: string | null;
  latitude: number;
  longitude: number;
  sortOrder: number;
  isFeatured?:boolean;
}

export interface ICommunityInitiativeModel {
  id: number;
  initiativeId: string;
  initiativeDisplayName: string;
  communityId?: number | null;
  communityName?: string;
  status: number;
  aboutTheInitiative: string;
  initiativeGuideline: string;
  eventAddress: string;
  documentBlobUrls: string;
  latitude: number;
  longitude: number;
  blobUrls: string;
  coverBlobUrl: string;
  isFeatured: boolean;
  sortOrder: number;
  linkedCampaignIds?: number[];
  linkedCampaigns?: ILinkedCampaign[];
  // Campaign type ids of the linked campaigns. A Registration campaign contributes its
  // RegistrationCampaignSubTypeEnum id (213/214) instead of 181 when it has a sub type.
  campaignTypes?: number[];
  createdOn?: Date | string;
  updatedOn?: Date | string;
  createdByName?: string;
  updatedByName?: string;
  stringStartDate?: string;
  stringEndDate?: string;
  airtableId?: string;
  startDate?: Date | string;
  endDate?: Date | string;
}

export interface ICommunityInitiativeCreateDto {
  initiative: ICommunityInitiativeModel;
}

export interface ICommunityInitiativeCampaignReorderItem {
  campaignId: number;
  sortOrder: number;
}

export interface ICommunityInitiativeCampaignReorderDto {
  campaigns: ICommunityInitiativeCampaignReorderItem[];
}

export interface IInitiativeOrderUpdateDto {
  initiativeId: number;
  sortOrder: number;
  isFeatured: boolean;
}

export interface IInitiativeOrderDto {
  id: number;
  initiativeDisplayName: string;
  isFeatured: boolean;
  sortOrder: number;
}

export interface ICommunityInitiativeListViewModel {
  id: number;
  initiativeId: string;
  initiativeDisplayName: string;
  communityId?: number | null;
  communityName?: string;
  status: number;
  aboutTheInitiative: string;
  initiativeGuideline: string;
  eventAddress: string;
  blobUrls: string;
  coverBlobUrl: string;
  isFeatured: boolean;
  sortOrder: number;
  linkedCampaignsCount: number;
  // Campaign type ids of the linked campaigns. A Registration campaign contributes its
  // RegistrationCampaignSubTypeEnum id (213/214) instead of 181 when it has a sub type.
  campaignTypes?: number[];
  publicCampaignTypes?: number[];
  createdOn?: Date | string;
  updatedOn?: Date | string;
  createdByName?: string;
  airtableId?: string;
  stringStartDate?: string;
  stringEndDate?: string;
  startDate?: Date | string;
  endDate?: Date | string;
}

export interface ILinkedInitiativeDto {
  id: number;
  initiativeDisplayName: string;
  communityId?: number | null;
  status: number;
  coverBlobUrl: string;
  createdOn: string;
  updatedOn?: string | null;
}

export interface CommunityInitiativeListWithInitiativeType {
  result: PagedResult<ICommunityInitiativeListViewModel>;
  hasPrivateInitiatives: boolean;
}

